module.exports = __webpack_public_path__ + "img/music.53abf1a5.jpg";